import React from "react";

const TransferIcon = ({ width, height, color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6884 0.122768C19.9339 0.301339 20.0343 0.539435 19.9897 0.837054L17.1326 17.9799C17.0954 18.1957 16.9764 18.3631 16.7755 18.4821C16.6713 18.5417 16.556 18.5714 16.4295 18.5714C16.3477 18.5714 16.2584 18.5528 16.1616 18.5156L11.1059 16.4509L8.4051 19.7433C8.27117 19.9144 8.08888 20 7.85823 20C7.76151 20 7.67966 19.9851 7.6127 19.9554C7.47134 19.9033 7.35787 19.8158 7.27231 19.6931C7.18674 19.5703 7.14396 19.4345 7.14396 19.2857V15.3906L16.7866 3.57143L4.85606 13.8951L0.44766 12.0871C0.172368 11.9829 0.0235611 11.7783 0.00124006 11.4732C-0.0136406 11.1756 0.105405 10.9561 0.358376 10.8147L18.9294 0.100446C19.0411 0.0334821 19.1601 0 19.2866 0C19.4354 0 19.5693 0.0409226 19.6884 0.122768Z"
        fill="white"
      />
    </svg>
  );
};
export default TransferIcon;
